// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./vendor.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eOoDxm3XSYoKbV_rQQUR {\r\n\tdisplay: inline;\r\n}\r\n\r\n.XreEI_c0pG3goR8ZidFv {\r\n\tfloat: left;\r\n}\r\n", "",{"version":3,"sources":["webpack://./app.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB;;AAEA;CAEC,WAAW;AACZ","sourcesContent":[".abcdef {\r\n\tdisplay: inline;\r\n}\r\n\r\n.xxx {\r\n\tcomposes: zzzz from \"./vendor.css\";\r\n\tfloat: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"abcdef": "eOoDxm3XSYoKbV_rQQUR",
	"xxx": "XreEI_c0pG3goR8ZidFv " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["zzzz"] + ""
};
export default ___CSS_LOADER_EXPORT___;
